import s from '@/components/Settings/settingsShared.module.scss'

/**
 * Class names for grouped settings `Paper` rows (Briefings, KPI cards).
 * Mirrors former `settingsRowPaperBaseSx` + `groupPositionPaperSx` (MUI theme spacing / shape).
 *
 * @param {{ groupPosition?: 'single' | 'first' | 'middle' | 'last', compactY?: boolean }} [opts]
 * @returns {string}
 */
export function settingsRowPaperClassName(opts = {}) {
  const { groupPosition, compactY } = opts
  const parts = [s.rowPaper]
  if (compactY) parts.push(s.rowPaperCompactY)
  if (groupPosition === 'first') parts.push(s.rowPaperGroupFirst)
  else if (groupPosition === 'middle') parts.push(s.rowPaperGroupMiddle)
  else if (groupPosition === 'last') parts.push(s.rowPaperGroupLast)
  parts.push(s.widthFull)
  return parts.join(' ')
}
